import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { AuthGaurd } from './shared/services/auth.gaurd';
import { BlankLayoutComponent } from './shared/components/layouts/blank-layout/blank-layout.component';
import { AdminLayoutSidebarCompactComponent } from './shared/components/layouts/admin-layout-sidebar-compact/admin-layout-sidebar-compact.component';
import { AdminLayoutSidebarLargeComponent } from './shared/components/layouts/admin-layout-sidebar-large/admin-layout-sidebar-large.component';

const adminRoutes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'partner',
    loadChildren: () => import('./views/partner/partner.module').then(m => m.PartnerModule)
  },
  {
    path: 'busniess',
    loadChildren: () => import('./views/busniess/business.module').then(m => m.BusinessModule)
  },
  {
    path: 'community',
    loadChildren: () => import('./views/community/community.module').then(m => m.CommunityModule)
  },
  {
    path: 'coupon',
    loadChildren: () => import('./views/coupon/coupon.module').then(m => m.CouponModule)
  },
  {
    path: 'orders',
    loadChildren: () => import('./views/orders/orders.module').then(m => m.OrdersModule)
  },
  {
    path: 'payacc',
    loadChildren: () => import('./views/payment/payment.module').then(m => m.PaymentModule)
  },

  // {
  //   path: 'forms',
  //   loadChildren: () => import('./views/forms/forms.module').then(m => m.AppFormsModule)
  // },
  // {
  //   path: 'invoice',
  //   loadChildren: () => import('./views/invoice/invoice.module').then(m => m.InvoiceModule)
  // },
  // {
  //   path: 'inbox',
  //   loadChildren: () => import('./views/inbox/inbox.module').then(m => m.InboxModule)
  // },
  // {
  //   path: 'calendar',
  //   loadChildren: () => import('./views/calendar/calendar.module').then(m => m.CalendarAppModule)
  // },
  // {
  //   path: 'chat',
  //   loadChildren: () => import('./views/chat/chat.module').then(m => m.ChatModule)
  // },
  // {
  //   path: 'contacts',
  //   loadChildren: () => import('./views/contacts/contacts.module').then(m => m.ContactsModule)
  // },
  // {
  //   path: 'tables',
  //   loadChildren: () => import('./views/data-tables/data-tables.module').then(m => m.DataTablesModule)
  // },
  // {
  //   path: 'pages',
  //   loadChildren: () => import('./views/pages/pages.module').then(m => m.PagesModule)
  // },
  // {
  //     path: 'icons',
  //     loadChildren: () => import('./views/icons/icons.module').then(m => m.IconsModule)
  // }
];

const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: 'dashboard/v1',
  //   pathMatch: 'full'
  // },
  {
    path: '',
    redirectTo: 'sessions/signin',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'sessions',
        loadChildren: () => import('./views/sessions/sessions.module').then(m => m.SessionsModule)
      }
    ]
  },
  {
    path: '',
    component: BlankLayoutComponent,
    children: [
      {
        path: 'others',
        loadChildren: () => import('./views/others/others.module').then(m => m.OthersModule)
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutSidebarLargeComponent,
    canActivate: [AuthGaurd],
    children: adminRoutes
  },
  {
    path: '**',
    redirectTo: 'others/404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
